import React, {useContext, useEffect, useLayoutEffect, useState} from 'react';
import {connect, shallowEqual, useSelector} from 'react-redux';

import {withTranslation} from 'react-i18next';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import * as inbox from "../_redux/inboxRedux";
import {
    get_assigned_tags,
    get_case_info,
    get_custom_fields,
    get_history_info,
    get_inbox_tasks, post_assigned_tags
} from "../_redux/inboxCrud";
import moment from 'jalali-moment';
import overlayFactory from 'react-bootstrap-table2-overlay';
import {useHistory} from "react-router-dom";
import postAuthenticatedJSON from "../../../common/utils/functions/postAuthenticatedJSON";
import {config} from "../../../config/config";
import {Button, Modal} from "react-bootstrap";
import CaseHistory from "./CaseHistory";
import TaskInfo from "./TaskInfo";
import Spinner from "../../../common/Spinner/Spinner";
import DualListBox from "react-dual-listbox";
import {get_inbox_filters, get_tag_list} from "../../../common/layout/_redux/layoutCrud";
import {smallBox} from "../../../common/utils/functions";
import classnames from "classnames";
import {AppConfig} from "../../../appConfig";


var receiveMessage = function(event) {
    if(event.data === "redirectToHomeLocation"){
        window.localStorage.setItem('loadForMessage',true);
        window.location.replace('/#/inbox')
        window.location.reload()
    }
}
window.addEventListener("message", receiveMessage, true);

window.addEventListener('DOMContentLoaded', (event) => {
    let messageFlag = window.localStorage.getItem('loadForMessage');
    if (messageFlag ==='true') {
        window.localStorage.setItem('loadForMessage', false);
    } else {
        window.localStorage.setItem('currentPage', 0);
    }
});

function Inbox(props) {
    const {apiServer} = useContext(AppConfig);

    let {state} = useSelector(
        (state) => ({
            state: state.inbox
        }),
        shallowEqual
    );
    if (state === undefined) state = {};
    let history = useHistory();

    useEffect(() => {


        if (state.is_inbox_loading === 0) {
            props.handle_variables('is_inbox_loading', 1)
            props.handle_variables('is_datatable_loading', true);
            let filters = {
                search_text: state.search_text,
                action: state.current_action,
                pro_uid: state.current_pro_uid,
                from_date: state.from_date,
                to_date: state.to_date,
                date_range: state.date_range
            };
            get_inbox_tasks(apiServer,window.localStorage.getItem('currentPage') || state.pg_current_page, state.pg_per_page, filters).then(res => {

                if(res.total < res.start) {
                    get_inbox_tasks(apiServer,0, state.pg_per_page, filters).then(res => {
                        props.tasks_loaded(res);  

                    }) 
                }else {
                    props.tasks_loaded(res);  

                }
            })
            get_inbox_filters(apiServer,state.current_action).then(res => {
                let items = [];
                res.map(x=>{
                    if(items[x.PRO_UID] === undefined)
                        items[x.PRO_UID] = {
                            "PRO_UID":x.PRO_UID,
                            "APP_PRO_TITLE":x.APP_PRO_TITLE,
                            "ITEMS":[
                                {
                                    "APP_TAS_TITLE":x.APP_TAS_TITLE,
                                    "TAS_UID":x.TAS_UID
                                }
                            ]
                        };
                    else {
                        let item = items[x.PRO_UID];
                        item.ITEMS.push({
                            "APP_TAS_TITLE":x.APP_TAS_TITLE,
                            "TAS_UID":x.TAS_UID
                        })
                        items[x.PRO_UID] = item;
                    }
                })
                items = Object.values(items)
                props.filters_loaded(items);
            })
            if (state.current_pro_uid !== "") {
                get_custom_fields(apiServer,state.current_pro_uid).then(res => {
                    props.set_custom_fields(res);
                })
            } else if (state.custom_fields.length > 0) {
                props.set_custom_fields([]);
            }
            if (state.tags_loaded === false) {
                get_tag_list(config.apiServer).then(res => {
                    props.handle_variables('tags', Object.keys(res).map(x => {
                        return res[x];
                    }));
                })
            }
        }
    });
        useEffect(()=>{
            props.closeSidebarCollapse("is_sidebar_collapsed",false);
            props.handle_refresh_menu();
        },[]);

    const handle_filter_change = (checked, id) => {
        let filters = state.filter_types;
        if (checked) {
            filters.push(id)
        } else {
            filters = filters.filter(x => x !== id)
        }
        props.handle_variables('filter_types', filters)

    }
    const handle_open_case = (item) => {
        if (item.action === 'unassigned') {
            postAuthenticatedJSON(
                config.apiServer + 'extrarest/case/' + item.app_uid + '/claim'
            ).then(res => {
            });
            history.push('/details/' + item.app_uid + '/' + item.del_index);
        } else {
            history.push('/details/' + item.app_uid + '/' + item.del_index);
        }
    }
    let columns = [
      
     {
        dataField: 'app_pro_title',
        text:<div className={'task-title-a task-title-header'}>{ props.t('Task Name')}</div>,
        headerAlign: 'right',
        align: 'right',
        formatter: function (cell, row) {
            return (<a href={'#/details/' + row.app_uid + '/' + row.del_index} >
                <div className={'task-title task-title-c'}>
                    <span>{row.app_tas_title}</span>
                </div>
                <small className={'task-title-c'}>{props.t("TaskNumber")}: {row.app_number}</small>
            </a>)
        },events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
                handle_open_case(row)
            },
        },
    },{
        dataField: 'app_tas_title',
        text:<div className={'task-title-a'}>{ props.t('Process Name')}</div>,
        
        headerAlign: 'center',
        align: 'center',
        formatter: function (cell, row) {
            return (<a href={'#/details/' + row.app_uid + '/' + row.del_index} >
                <div className={'task-title task-title-b'}>
                    <span> {row.app_pro_title}</span>
                </div>
            </a>)
        },events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
                handle_open_case(row)
            },
        },
    }, {
        dataField: 'app_pro_title2',
        text: <div className={'task-title-a'}></div>,
        
        headerAlign: 'center',
        align: 'center',
        formatter: function (cell, row) {
            let tags =  Object.values(row.tags);
            return (<>
                <div className={'task-title '}>
                    {tags.map(x=>{
                        return <span className={'badge'} style={{backgroundColor:x.COLOR}}>{x.TITLE}</span>
                    })}
                </div>
            </>)
        }
    }];
    state.custom_fields.map((x, key) => {
        columns.push({
            dataField: x.var_name,
            text: <div className={'task-title-a'}>{x.var_label}</div>,
            formatter: function (cell, row) {
                let temp = "";
                if (row.default_variable !== null && row.default_variable !== undefined) {
                    if (row.default_variable.var_name === x.var_name) temp = row.default_variable.var_value
                }
                if (row.variables !== null) {
                    row.variables.map(y => {
                        if (row.default_variable !== null && row.default_variable !== undefined) {
                            if (row.default_variable.var_name === x.var_name) temp = row.default_variable.var_value
                        }
                        if (row.variables !== null) {
                            row.variables.map(y => {
                                if (y.var_name === x.var_name) temp = y.var_value
                                return y;
                            })
                        }
                        return y;
                    })
                }
                return (<a href={'#/details/' + row.app_uid + '/' + row.del_index} >{temp}</a>)
            }
        })
        return x;
    })
    const show_process_map = (item) => {
        history.push('/process-map/' + item.app_uid + '/' + item.pro_uid);
    }
    const show_history = (item) => {
        props.handle_history_modal(true);
        get_history_info(apiServer,item.app_uid).then(res => {
            // res = res.reverse();
            props.history_loaded(res);

        })
            .catch(error => {
                // this.handleError(error);
            });
    }
    const show_info = (item) => {
        props.handle_info_modal(true);
        get_case_info(apiServer,item).then(res => {
            props.info_loaded(res);
        })
            .catch(error => {
                // this.handleError(error);
            });
    }
    const show_tags = (item,uid) => {
        props.handle_tag_modal(true);
        getSelectedTag(uid)
    }
    columns = columns.concat([
        {
            dataField: 'previous_user',
            text:<div className={'task-title-a'}>{props.t("Erja")}</div> ,
            headerAlign: 'center',
            align: 'center',
            formatter: function (cell, row) {
                return (<>
                    <a href={'#/details/' + row.app_uid + '/' + row.del_index} >
                    <div>{row.previous_user}</div>
                    <small>{moment(row.del_delegate_date, 'YYYY-M-D HH:mm:ss').locale('fa').format('YYYY/MM/DD')}</small>
                    </a>
                </>)
            }
        }, {
            dataField: 'actions',
            text: <div className={'task-title-a'}>{props.t("Action")}</div> ,
            headerAlign: 'center',
            align: 'center',
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    if (e.target.classList.contains('context-menu-toggle')) {
                        if (state.current_context_holder !== row.app_uid)
                            props.handle_variables('current_context_holder', row.app_uid)
                        else
                            props.handle_variables('current_context_holder', null)
                    }

                },
            },
            formatter: function (cell, row) {
                return (<>
                    <div className={'action-holder text-center context-menu-toggle'}>
                        <i className="fas fa-ellipsis-v context-menu-toggle"></i>
                    </div>
                    {state.current_context_holder !== row.app_uid ? null : <>
                        <div className={'p-relative'} >
                            <div className={'context-menu'}
                            onMouseLeave={() => {
                                props.handle_variables('current_context_holder', null)
                            }}>
                                <ul>
                        <li onClick={() => show_process_map(row)}>{props.t("ProcessMap")}</li>
                                    <li onClick={() => show_history(row)}>{props.t("ProcessHistory")}</li>
                                    <li onClick={() => show_info(row)}>{props.t("ProcessInfo")}</li>
                                    <li onClick={() => show_tags(true,row.app_uid)}>{props.t("ProcessTag")}</li>
                                </ul>
                            </div>
                        </div>
                    </>}
                </>)
            }
        }
    ])
    const rowClasses = (row, rowIndex) => {
        if (row.del_init_date !== null)
            return "";
        else
            return 'unread-row';
    };
    const handle_on_page_change = (page, sizePerPage , filterOfRead="") => {



        props.handle_variables('is_datatable_loading', true);
        let filters = {
            search_text: state.search_text,
            action: state.current_action,
            pro_uid: state.current_pro_uid,
            from_date: state.from_date,
            to_date: state.to_date,
            date_range: state.date_range
        };
        get_inbox_tasks(apiServer,page - 1, sizePerPage, filters, filterOfRead).then(res => {
            props.tasks_loaded(res);
            window.localStorage.setItem('currentPage',page - 1);
        })
    }
    const handleTableChange = (page, sizePerPage) => {

    }
    const handle_on_per_page_change = (sizePerPage, page) => {

        props.handle_variables('is_datatable_loading', true);
        let filters = {
            search_text: state.search_text,
            action: state.current_action,
            pro_uid: state.current_pro_uid,
            from_date: state.from_date,
            to_date: state.to_date,
            date_range: state.date_range
        };
        get_inbox_tasks(apiServer,page - 1, sizePerPage, filters).then(res => {
            props.tasks_loaded(res);
            window.localStorage.setItem('currentPage',page - 1);
        })
    }
    const handelAssignTags = selected => {
        let forAssign = selected.filter(data => {
            return state.existing_tag_ids.indexOf(data) < 0;
        });
        let forUnAssign = state.existing_tag_ids.filter(data => {
            return selected.indexOf(data) < 0;
        });
        if(forAssign.length > 0 || forUnAssign.length > 0) {
            post_assigned_tags(apiServer,state.current_app_uid,selected).then(res=>{
                props.handle_variables('existing_tag_ids',selected);
                handle_on_page_change(state.pg_current_page,state.pg_per_page)
                smallBox({
                    title: props.t('Successfully'),
                    content: '<i>' + props.t('Data has been saved successfully') + '</i>',
                    color: '#659265',
                    iconSmall: 'fa fa-check fa-2x fadeInRight animated',
                    timeout: 4000,
                });
            })
        }
    };

    const getSelectedTag = id => {
        get_assigned_tags(apiServer,id).then(res=>{
            let ids = [];
            Object.values(res).map(d => {
                ids.push(d.ID);
            });
            props.handle_variables('existing_tag_ids',ids);
            props.handle_variables('current_app_uid',id);
        })
    };
    const handle_header_filter =(event,filter) =>{
        handle_on_page_change(1,state.pg_per_page,filter);
        let all = (filter ==='all');
        let read = (filter==='read');
        let unread = (filter ==='unread');
        props.handle_variables('filter_flags', {all,read,unread});
    }
    return (
        <div className={'datatable-holder'}>
            <div style={{backgroundColor:'#efefef'}}>
                <button className={classnames('btn btn-sm btn-secondary', { 'filter_underline':state.filter_flags.all })}  onClick={(e)=>handle_header_filter(e,'all')}> {props.t("All")} <span className="badge badge-light">{(state.total_read + state.total_unread) || 0}</span></button>
                <button className={classnames('btn btn-sm btn-secondary', { 'filter_underline': state.filter_flags.read })}  onClick={(e)=>handle_header_filter(e,'read')}>  {props.t("Readed")} <span className="badge badge-light">{state.total_read}</span></button>
                <button className={classnames('btn btn-sm btn-secondary', { 'filter_underline': state.filter_flags.unread })} onClick={(e)=>handle_header_filter(e,'unread')}> {props.t("Unreaded")}  <span className="badge badge-light">{state.total_unread}</span></button>
            </div>
            <BootstrapTable
                keyField='app_uid'
                data={state.tasks}
                striped
                hover
                noDataIndication={props.t("No item exists")}
                columns={columns}
                loading={state.is_datatable_loading}
                overlay={overlayFactory()}
                rowClasses={rowClasses}
                onTableChange={handleTableChange}
                remote={{pagination: true, filter: true, sort: true}}
                pagination={paginationFactory(
                    {
                        page: state.pg_current_page, // Specify the current page. It's necessary when remote is enabled
                        sizePerPage: state.pg_per_page, // Specify the size per page. It's necessary when remote is enabled
                        totalSize: state.pg_total_size, // Total data size. It's necessary when remote is enabled
                        showTotal: true,
                        alwaysShowAllBtns: true, // always show the next and previous page button
                        firstPageText: props.t("First"), // the text of first page button
                        prePageText: props.t("Previous"), // the text of previous page button
                        nextPageText: props.t("Next"), // the text of next page button
                        lastPageText: props.t("Last"), // the text of last page button
                        nextPageTitle: props.t("GoNext"), // the title of next page button
                        prePageTitle: props.t("GoPrevios"), // the title of previous page button
                        firstPageTitle: props.t("GoFirst"), // the title of first page button
                        lastPageTitle: props.t("GoLast"), // the title of last page button
                        hidePageListOnlyOnePage: true,
                        paginationTotalRenderer: (from, to, size) => {
                        return <></>
                        },
                        onPageChange: handle_on_page_change,
                        onSizePerPageChange: handle_on_per_page_change
                    }
                )}
            />
            <Modal show={state.open_history_modal} onHide={() => props.handle_history_modal(false)}>
                <Modal.Header closeButton>
                <Modal.Title>{props.t("ProcessHistory")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {state.is_modal_loading === true ? <>
                        <Spinner/>
                    </> : <>
                        <CaseHistory caseHistories={state.history_items}/>
                    </>}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => props.handle_history_modal(false)}>
                       {props.t("Return")}
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={state.open_info_modal} onHide={() => props.handle_info_modal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{props.t("ProcessInfo")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {state.is_modal_loading === true ? <>
                        <Spinner/>
                    </> : <>
                        {state.info_items === null ? null : <>
                            <TaskInfo taskInfo={state.info_items}/>
                        </>}
                    </>}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => props.handle_info_modal(false)}>
                    {props.t("Return")}
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={state.open_tag_modal} onHide={() => props.handle_info_modal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{props.t("ProcessTag")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <DualListBox
                        canFilter
                        filterCallback={(option, filterInput) => {
                            if (filterInput === '') {
                                return true;
                            }

                            return new RegExp(filterInput, 'i').test(option.label);
                        }}
                        filterPlaceholder={props.t('Search')}
                        options={state.tags.map(x => ({
                            value: x.ID,
                            label: x.TITLE,
                        }))}
                        selected={state.existing_tag_ids}
                        onChange={handelAssignTags}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => props.handle_tag_modal(false)}>
                    {props.t("Return")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default connect(null, inbox.actions)(withTranslation()(Inbox));